module.exports = __webpack_public_path__ + "media/images/giphy_attribution-089b02423efe69b4375bf9fafe125f8a.png";